import { getSelectedServiceId } from './getSelectedServiceId';
import { getServices } from './getServices';
import { getServiceId } from '../../../utils/publishTerms';
import { mapServices } from './mapServices';
import { mapAuction } from './mapAuction';
import { mapCalltracking } from './mapCalltracking';
import { getPackageId } from './getPackageId';
import { mapPackages } from './mapPackages';
import { getSelectedPackageId } from './getSelectedPackageId';
import { mapMultiposting } from './mapMultiposting';
import { mapPeriodsByService } from './mapPeriodsByService';
import { getSelectedPeriodId } from './getSelectedPeriodId';
import { mapPublication } from './mapPublication';
import { IPublishTermsSuccessPayload } from '../../../actions/publishTerms';
import { IAddFormPublishTermsResponse } from '../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import {
  EPlacingType,
  EPublishTermsAvailableMoneySources,
  EPublishTermsStatus,
  IPublishTermsMessage,
  IPublishTermsState,
} from '../../../types/reducers/publishTerms';
import { mapRecommendedPackage } from './recommendedPackages';
import { defaultTo } from 'ramda';
import { mapMoneySources, mapPaidPublication, mapPromotion } from './mapPublishTermsV1ToV2';
import { mapPublicationPackages } from './mapPublicationPackages';

export const mapPublishTerms = (response: IAddFormPublishTermsResponse): IPublishTermsSuccessPayload => {
  const { autoProlong, moneySource, availableMoneySources } = response;

  const message = defaultTo(null, response.message as IPublishTermsMessage);

  const rawPackages = defaultTo([], response.servicePackages);
  const rawRecommendedPackages = defaultTo([], response.recommendedServicePackages);

  const packageIds = rawPackages.map(getPackageId);
  const packages = mapPackages(rawPackages);
  const selectedPackageId = getSelectedPackageId(rawPackages);

  const terms = getServices(response);
  const serviceIds = terms.map(term => getServiceId(term.services));
  const services = mapServices(terms);
  const selectedServiceId = getSelectedServiceId(terms);

  const periodsByService = mapPeriodsByService(terms);
  const selectedPeriodId = getSelectedPeriodId(terms, selectedServiceId);

  const auction = mapAuction(response.auction);
  const calltracking = mapCalltracking(response.calltracking);
  const publication = mapPublication(response.publication);

  const selectedPlacingType = response.isAllowPackage ? EPlacingType.package : EPlacingType.balance;

  const { isMultipostingAvailable, multipostingABGroup } = mapMultiposting(response.multiposting);

  // TODO: Для мапинга рекомендованного пакета услуги "Оптом дешевле" используй mapRecommendedPackage
  const publishTerms: IPublishTermsState = {
    autoProlong,
    status: EPublishTermsStatus.success,
    isServicesReloading: false,
    error: null,
    serviceIds,
    services,
    selectedServiceId,
    promotionServiceId: null,
    message,
    isMultipostingAvailable,
    multipostingABGroup,
    packageIds,
    packages,
    selectedPackageId,
    periodsByService,
    selectedPeriodId,
    selectedPlacingType,
    isPlacingTypeChangedByUser: false,
    publication,
    moneySource: defaultTo(null, moneySource),
    isServicesEnabled: response.auction ? !response.auction.withoutPromotion : false,
    availableMoneySources: availableMoneySources as string as EPublishTermsAvailableMoneySources,
    highDemandCoefficient: defaultTo(null, response.highDemandCoefficient),
    promotionTypeChangeReason: null,
  };

  const recommendedPackages = rawRecommendedPackages.map(mapRecommendedPackage);

  return {
    publishTerms,
    auction,
    calltracking,
    recommendedPackages,
    dataV2: {
      paidPublication: mapPaidPublication(response),
      recommendedPackages,
      publicationPackages: mapPublicationPackages(defaultTo([], response.servicePackages)),
      promotion: mapPromotion(response),
      moneySources: mapMoneySources(response),
    },
  };
};
